import { takeEvery, all, put, select } from 'redux-saga/effects'
import { startSubmit, stopSubmit } from 'redux-form/immutable'
import { push } from 'connected-react-router'
import { triggerPutProtrack, putProtrack } from '../actions'
import { getViewProtrackId, getTypeOfLevelForViewProTrack } from '../selectors'
import { postLevelsList } from 'store/entities/protracks/levels/actions'
import { getLevelsListForRequest } from 'store/entities/protracks/levels/selectors'
import { showSuccess } from 'store/entities/toastr/utils'
import { EDIT_PROTRACK_FORM_NAME as FORM_NAME } from 'app/constants/protracks'
import { getTouchedLevels, getBlockedPathName } from 'store/entities/protracks/unsavedChanges/selectors'
import { reset as resetUnsavedChanges } from 'store/entities/protracks/unsavedChanges/actions'
import i18next from 'i18next'

/**
 * TODO: this file should be removed, because we can use this docs:
 * @see: https://github.com/prohabits/prohabits-ui/wiki/API-Requests
 */
export function* handlePutRequest({ payload: { values, shouldLeavePage } }) {
  yield put(startSubmit(FORM_NAME))
  const protrackId = yield select(getViewProtrackId)
  const levelsTouched = yield select(getTouchedLevels)
  const typeOfLevel = yield select(getTypeOfLevelForViewProTrack)
  yield putProtrack.call({ protrackId, data: values, shouldLeavePage })
  if (levelsTouched) {
    const levels = yield select(getLevelsListForRequest)
    yield postLevelsList.call({ protrackId, values: { orders: levels, typeOfLevel } })
  }
}

export function* handlePutSuccess({ payload: { data }, meta: { shouldLeavePage } }) {
  const blockedPathName = yield select(getBlockedPathName)
  yield put(resetUnsavedChanges())
  yield put(stopSubmit(FORM_NAME))
  if (shouldLeavePage && blockedPathName) {
    yield put(push(blockedPathName, { forceLeave: true }))
  }
  showSuccess({ content: i18next.t('You successfully updated activity', { name: data.name }) })
}

export function* handlePutFail({ payload: { error } }) {
  console.error('error', error)
  yield put(stopSubmit(FORM_NAME))
}

export default function* unsubscribeProgressSaga() {
  yield all([
    takeEvery(triggerPutProtrack.toString(), handlePutRequest),
    takeEvery(putProtrack.success.toString(), handlePutSuccess),
    takeEvery(putProtrack.fail.toString(), handlePutFail),
  ])
}
